import appStore             from '@/stores/appStore';
import { EllipsisOutlined } from '@ant-design/icons';
import Button               from '@widesk-ui/components/Button';
import View                 from '@widesk-ui/components/View';
import { observer }         from 'mobx-react-lite';
import { navigate }         from '@widesk-ui/hooks/useNavigate';
import { Dispatch }         from 'react';
import { SetStateAction }   from 'react';
import Image                from '@widesk-ui/components/Image';

type SiderSelectWebsiteEntertainmentItemProps = {
	collapsedState: [boolean, Dispatch<SetStateAction<boolean>>],
	selected?: boolean,
	title: string,
	id: string,
	sidebarImage?: { url: string; '@urn': Urn },
};

const SiderSelectWebsiteEntertainmentItem = ({ collapsedState, selected, title, id, sidebarImage }: SiderSelectWebsiteEntertainmentItemProps) => {
	const [collapsed, setCollapsed] = collapsedState;

	return (
		<Button
			title={title}
			tooltipProps={{ placement: 'right' }}
			style={{ padding: 0, height: 'auto', opacity: selected ? undefined : .4 }}
			onClick={() => {
				if (appStore.websiteEntertainment?.id === id) {
					if (collapsed) {
						setCollapsed(false);
					}

					if (appStore.isConfigurationMenuOpened) {
						return appStore.setConfigurationMenuOpened(false);
					}
				}

				navigate('/website_entertainments/' + id + '/home');
			}}
			type="primary"
		>
			{sidebarImage ? (
				<Image src={sidebarImage.url} preview={false} size="middle" />
			) : (
				<EllipsisOutlined />
			)}
		</Button>
	);
};

type SiderSelectWebsiteEntertainmentProps = {
	collapsedState: [boolean, Dispatch<SetStateAction<boolean>>];
}

const SiderSelectWebsiteEntertainment = observer(function (props: SiderSelectWebsiteEntertainmentProps) {
	const { collWebsiteEntertainment, websiteEntertainment } = appStore;

	return (
		<View
			marginV={1}
			width={54}
			marginR={1}
			style={{ flexShrink: 0 }}
			gap={5}
			padding={4}
			className="main-menu__buttons"
		>
			{collWebsiteEntertainment.map(we => (
				<SiderSelectWebsiteEntertainmentItem
					collapsedState={props.collapsedState}
					key={we.id}
					selected={we.id === websiteEntertainment?.id}
					title={we.modelLabel}
					id={we.id}
					sidebarImage={we.files['website_entertainment_sidebar_image']?.at(0)}
				/>
			))}
		</View>
	);
});

export default SiderSelectWebsiteEntertainment;
